/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryDefinitionProviderAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class QueryDefinitionProviderAPI {

		/**
		 * @function QueryDefinitionProviderAPI#supports
		 * @description Determine whether the instance of QueryDefinitionProviderAPI supports the given content
		 * @public
		 *
		 * @param {ContentAPI}
		 * @return {boolean}
		 */
		supports() {}

		/**
		 * @function QueryDefinitionProviderAPI#populateDefinition
		 * @description Populate query definitions
		 * @public
		 *
		 * @return {Promise<QueryDefinitionAPI[]>} a list of query definitions
		 */
		getQueryDefinitionList() {}

		/**
		 * @return {String} the type of the provider
		 */
		getType() {}
	}

	return QueryDefinitionProviderAPI;
});
